"use strict";
// This fix should add a minimum amount of spacing underneath square root symbols
// so the root index does not overlap with the symbol. Specifically needed for
// fractional indices, it also provides better spacing for all square root expressions
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixSqrtSpacing = void 0;
function fixSqrtSpacing(tex) {
    return tex.replace(/\\sqrt\[([^\]]*)]\{/g, "\\sqrt[$1]{\\vphantom{A}");
}
exports.fixSqrtSpacing = fixSqrtSpacing;
